/* @flow */
import React, { Component } from 'react';
import Chip from 'material-ui/Chip';
import { green200, red300 } from 'material-ui/styles/colors';

const styles = {
  chip: {
    margin: 4,
  },
  chipPositive: {
    margin: 4,
  },
  chipNegative: {
    margin: 4,
  },
  chipWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

type Props = {
  open: boolean,
  values: any,
  fieldMap: any,
};

export default class FilterDisplay extends Component<Props> {
  /**
   * do not update when the dialog is open
   * @returns {boolean}
   */
  shouldComponentUpdate() {
    return !this.props.open;
  }

  render() {
    const { fieldMap, values } = this.props;

    return (
      <div style={styles.chipWrapper}>
        {' '}
        {Object.entries(fieldMap)
          .filter(
            ([key]) =>
              // Filter out undefined values
              key in values
          )
          .map(([key, name]) => {
            const value = values[key];

            if (typeof value === 'boolean') {
              // Only render positive boolean values
              if (value) {
                return (
                  <Chip
                    key={key}
                    // onRequestDelete={() => this.handleRequestDelete(data.key)}
                    backgroundColor={value ? green200 : red300}
                    style={styles.chip}
                  >
                    {name}
                  </Chip>
                );
              }
            } else if (value) {
              // ignore falsy values
              const display = value.text ? value.text : value;

              return (
                <Chip
                  key={key}
                  backgroundColor={green200}
                  // onRequestDelete={() => this.handleRequestDelete(data.key)}
                  style={styles.chip}
                >
                  {`${String(name)}: ${String(display)}`}
                </Chip>
              );
            }

            return null;
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/components/FilterDisplay.js